export default {"src":"https://images-cdn.curipod.com/d-4052e23f/_next/static/media/loaderstars.62e39e18.svg","height":669,"width":679};